import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGift2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGift2"><Path d="M12 3.5H3.5V12M12 3.5H20.5V12M12 3.5V12M20.5 12V20.5H12M20.5 12H12M12 20.5H3.5V12M12 20.5V12M3.5 12H12M12 12C10.7801 13.8421 9.35422 15.3033 7.5 16.5M12 12C13.2199 13.8421 14.6458 15.3033 16.5 16.5M12 12V10.5M12 12H10.5C8.84315 12 7.5 10.6569 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C10.6569 7.5 12 8.84315 12 10.5M12 12H13.5C15.1569 12 16.5 10.6569 16.5 9C16.5 8.17157 15.8284 7.5 15 7.5C13.3431 7.5 12 8.84315 12 10.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGift2;
